import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import WaterOpening from '../views/WaterOpening.vue'
import WorkComponent from '@/components/WorkComponent.vue'
import WorkScroll from '@/components/WorkScroll.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '',
    component: WaterOpening,
  },
  {
    path: '/work',
    name: 'Home',
    component: Home,
    props: true,
    children: [
      {
        path: '/work',
        component: WorkScroll,
        meta: {
          keepAlive: true
        },
      },
      {
        path: '/work/:title',
        component: WorkComponent,
        meta: {
          keepAlive: false
        },
        props: route => ({ sTitle: `${route.params.title}` })
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
  },
  {
    path: '/available',
    name: 'Available',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Available.vue')
  }
]


const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    console.log(to, from, savedPosition);
    if (savedPosition) {
      return savedPosition;
    }
    else {
      return { x: 0, y: 0 }
    }
  }
})

export default router